import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-jobs-sidebar',
  templateUrl: './page-jobs-sidebar.component.html',
  styleUrls: ['./page-jobs-sidebar.component.css'],
  standalone: false,
})
export class PageJobsSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
